export default ($api) => ({
  videoKinhTeXaHoi: (data) => {
    return $api.get(`video-kinh-te-xa-hoi-page`, { params: data })
  },
})
